import Wow from "wow.js";
import Swiper from "swiper";
const plg = require("../autoload/functions-comunes");
require("../autoload/plugins/chosen");

/**
 * [wow description]
 * @type {Wow}
 */
const wow = new Wow();
wow.init();

/**
 * [swiper description]
 * @type {Swiper}
 */
/*
const swiper = new Swiper(".swiper-container", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
swiper.init();
*/

/**
 * [chosen-select description]
 * @type {[type]}
 */
$(".chosen-select").chosen({
  disable_search_threshold: 10
});

/**
 * LISTENER menus con ancla
 * @param  {[type]} e){	e.preventDefault();	var ancla         [description]
 * @return {[type]}                              [description]
 */
$(".js-menu-ancla").click(function(e) {
  e.preventDefault();
  var ancla = $(this).attr("href");
  var offset = $(this).data("menuancla-offset");
  if (offset == "" || offset == undefined) {
    offset = 0;
  }
  plg.PLG_scrollTo(1, ancla, 0, offset, 0);
});

/**
 * LISTENER para mostrar modal alerta
 */
$(".js-modal-alerta").click(function(e) {
  e.preventDefault();
  plg.PLG_showModalAlerta(
    $(this).data("alerta-titulo"),
    $(this).data("alerta-texto")
  );
});

/**
 * LISTENER cierre cookies
 */
$("#modal-cookies .close").click(function() {
  $("#modal-cookies").fadeOut();
  plg.PLG_setCookie("accept.cookies", "true", 365);
});
plg.PLG_checkCookie();

/**
 * LISTENER copiar de un input
 */
$(".js-btn-copy").click(function() {
  var target = $(this).data("target-copy");
  plg.PLG_copyToClipboard(document.getElementById(target));
});



// WEBPACK FOOTER //
// ./scripts/autoload/functions-initlisteners.js